import { FC, useState } from 'react';

import { Flex, Tooltip, TooltipProps } from 'antd';

import './InfoTooltip.scss';

import Close from '../icons/Close';

interface ITooltipProps {
	header?: string;
	description: string;
	trigger?: TooltipProps['trigger'];
	children?: React.ReactNode;
	placement?: TooltipProps['placement'];
	defaultOpen?: boolean;
}

const InfoTooltip: FC<ITooltipProps> = ({
	header,
	description,
	trigger = ['click'],
	children,
	placement = 'top',
	defaultOpen = false,
}) => {
	const [open, setOpen] = useState(defaultOpen);

	return (
		<Tooltip
			open={open}
			placement={placement}
			rootClassName="tooltip-body"
			title={
				<>
					<Flex gap={32}>
						<div>
							{header && <h4>{header}</h4>}
							<p>{description}</p>
						</div>
						{trigger.includes('click') ? <Close onClick={() => setOpen(false)} /> : null}
					</Flex>
				</>
			}
			trigger={trigger}
			onOpenChange={(value) => setOpen(value)}
		>
			{children}
		</Tooltip>
	);
};

export default InfoTooltip;
